var map = {
	"./rongyu.png": "c9b0",
	"./rongyu_en.png": "7dc4",
	"./rongyu_es.png": "99d0",
	"./rongyu_hk.png": "a1c3",
	"./rongyu_pt.png": "cef5",
	"./rongyu_tr.png": "6659"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8694";